import { memo } from 'react';

const TextWithEllipsis = memo(({ children, className, title, ...props }) => {
  return (
    <div className={`comp-text-with-ellipsis ${className || ''}`} data-title={title} {...props}>
      {children}
    </div>
  );
});

TextWithEllipsis.displayName = 'TextWithEllipsis';

export default TextWithEllipsis;
